import { render, staticRenderFns } from "./ClientEmptyMessage.vue?vue&type=template&id=5f840a28&scoped=true&"
import script from "./ClientEmptyMessage.vue?vue&type=script&lang=js&"
export * from "./ClientEmptyMessage.vue?vue&type=script&lang=js&"
import style0 from "./ClientEmptyMessage.vue?vue&type=style&index=0&id=5f840a28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f840a28",
  null
  
)

export default component.exports